import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_6 = { class: "ss-tela-titulo" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, "Central de Faturamentos", -1)
const _hoisted_8 = { class: "atalhos" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Remover dos Meus Atalhos", -1)
const _hoisted_10 = {
  style: {"color":"orange","font-size":"20px"},
  class: "anticon"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar aos Meus Atalhos", -1)
const _hoisted_12 = { class: "anticon" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-24 ant-col-xl-5",
  style: {"padding-top":"4px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-btn-group ss-tamanho-completo" })
], -1)
const _hoisted_14 = { class: "ss-tela-conteudo" }
const _hoisted_15 = { class: "ss-card ss-card-space" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "MOVIMENTOS:")
], -1)
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "STATUS:")
], -1)
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "PERÍODO:")
], -1)
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_24 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_28 = { class: "ss-card ss-card-space ss-alinhar-texto-esquerda" }
const _hoisted_29 = {
  class: "ant-row",
  style: {"margin-top":"15px"}
}
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = { key: 4 }
const _hoisted_37 = {
  key: 5,
  class: "acoes-item"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_filtro_periodo_movimento_comercial = _resolveComponent("selecionar-filtro-periodo-movimento-comercial")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_totalizador_decorado = _resolveComponent("totalizador-decorado")!
  const _component_card = _resolveComponent("card")!
  const _component_coluna_grade = _resolveComponent("coluna-grade")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_faturamento_vendas_modal = _resolveComponent("faturamento-vendas-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (_ctx.storeSistema.getters.atalhoAdicionado(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas))
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_9
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removerAtalho(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas)))
                        }, [
                          _createElementVNode("i", _hoisted_10, [
                            _createVNode(_component_icone, { nome: "estrela" })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 1,
                      placement: "bottom"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_11
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarAtalho(_ctx.telaBase.identificadorRecurso, _ctx.telaBase.empresasSelecionadas)))
                        }, [
                          _createElementVNode("i", _hoisted_12, [
                            _createVNode(_component_icone, { nome: "favorito" })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
              ])
            ])
          ]),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_select, {
                      class: "ss-tamanho-completo",
                      value: _ctx.state.filtros.movimentosComerciais,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.filtros.movimentosComerciais) = $event)),
                      mode: "multiple",
                      placeholder: "Todos",
                      "show-search": "",
                      optionFilterProp: "label",
                      allowClear: true,
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.buscarFaturamentos()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Devolução de Compras")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 3 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Vendas")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 4 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Devolução de Vendas")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_select, {
                      class: "ss-tamanho-completo",
                      value: _ctx.state.filtros.status,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.filtros.status) = $event)),
                      placeholder: "Selecione",
                      "show-search": "",
                      optionFilterProp: "label",
                      allowClear: true,
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.buscarFaturamentos()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Aguardando Faturamento")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Faturados")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: 3 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cancelados")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_selecionar_filtro_periodo_movimento_comercial, {
                      valor: _ctx.state.filtros.periodo,
                      "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.filtros.periodo) = $event)),
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.periodoAlterado()))
                    }, null, 8, ["valor"]),
                    ((_ctx.state.filtroPeriodo === _ctx.EFiltroPeriodoMovimentoComercial.Personalizado))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_a_form_item, {
                              label: "Data Inicial e Final",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data_inicial_final, {
                                  dataInicialSelecionada: _ctx.state.filtros.dataInicial,
                                  "onUpdate:dataInicialSelecionada": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.filtros.dataInicial) = $event)),
                                  dataFinalSelecionada: _ctx.state.filtros.dataFinal,
                                  "onUpdate:dataFinalSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.filtros.dataFinal) = $event)),
                                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.buscarFaturamentos()))
                                }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_busca_geral, {
                      empresas: _ctx.state.filtros.empresas,
                      ordenacao: _ctx.telaBase.ordenacaoSelecionada,
                      "onUpdate:ordenacao": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                      buscaRapida: _ctx.state.filtros.valorBuscaRapida,
                      "onUpdate:buscaRapida": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.filtros.valorBuscaRapida) = $event)),
                      buscaAvancada: _ctx.state.buscaAvancada,
                      onBuscarDados: _ctx.buscarFaturamentos,
                      class: "ss-tamanho-completo"
                    }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_card, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Visualizar Todos - Aguardando Faturamento"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_totalizador_decorado, {
                              class: "ss-totalizador-decorado",
                              titulo: "AGUARDANDO FATURAMENTO",
                              cor: "#ffeb3b",
                              iconeColorido: true,
                              monetario: true,
                              valor: _ctx.obtemValorTotalizador(_ctx.EStatusFiltroFaturamento.AguardandoFaturamento),
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.buscarFaturamentosPorStatus(_ctx.EStatusFiltroFaturamento.AguardandoFaturamento)))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Visualizar Todos - Faturados"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_totalizador_decorado, {
                              class: "ss-totalizador-decorado",
                              titulo: "FATURADOS",
                              cor: "#87e22d",
                              iconeColorido: true,
                              monetario: true,
                              valor: _ctx.obtemValorTotalizador(_ctx.EStatusFiltroFaturamento.Faturados),
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.buscarFaturamentosPorStatus(_ctx.EStatusFiltroFaturamento.Faturados)))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_a_tooltip, {
                          placement: "top",
                          title: "Visualizar Todos - Cancelamentos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_totalizador_decorado, {
                              class: "ss-totalizador-decorado",
                              titulo: "CANCELAMENTOS",
                              cor: "#f44336",
                              iconeColorido: true,
                              monetario: true,
                              valor: _ctx.obtemValorTotalizador(_ctx.EStatusFiltroFaturamento.Cancelados),
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.buscarFaturamentosPorStatus(_ctx.EStatusFiltroFaturamento.Cancelados)))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                (_openBlock(), _createBlock(_component_a_table, {
                  key: 'FATURMENTOS' + _ctx.state.chaveFaturamentos,
                  columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                  "data-source": _ctx.state.faturamentos,
                  scroll: _ctx.storeSistema.state.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth +150) },
                  rowKey: "codigo",
                  pagination: false,
                  loading: _ctx.telaBase.carregando,
                  size: "small"
                }, {
                  headerCell: _withCtx(({ column }) => [
                    _createVNode(_component_coluna_grade, {
                      column: column,
                      ordenacaoSelecionada: _ctx.telaBase.ordenacaoSelecionada,
                      "onUpdate:ordenacaoSelecionada": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                      filtrosCabecalho: _ctx.gradeBase.filtrosCabecalho,
                      "onUpdate:filtrosCabecalho": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.gradeBase.filtrosCabecalho) = $event)),
                      onBuscarDados: _ctx.buscarFaturamentos
                    }, null, 8, ["column", "ordenacaoSelecionada", "filtrosCabecalho", "onBuscarDados"])
                  ]),
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.key === 'Numero')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.visualizarFaturamento(record))
                        }, _toDisplayString(record.numero), 9, _hoisted_33))
                      : (column.key === 'Status')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            style: {"vertical-align":"middle","height":"15px","border-radius":"45px"},
                            color: _ctx.obterCorStatus(record.movimentoComercial, record.status)
                          }, null, 8, ["color"]))
                        : (column.key === 'Pessoa')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(record.nomeRazaoSocialPessoa), 1))
                          : (column.key === 'DataMovimentacao')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataMovimentacao)), 1))
                            : (column.key === 'Total')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.total)), 1))
                              : (column.key === 'acoes')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.visualizarFaturamento(record)),
                                      title: "Visualizar"
                                    }, [
                                      _createVNode(_component_icone, {
                                        style: {"font-size":"18px"},
                                        nome: "visualizar"
                                      })
                                    ], 8, _hoisted_38),
                                    (_ctx.exibirFaturamento(record.movimentoComercial, record.status))
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "visualizar",
                                          title: "Faturar",
                                          onClick: ($event: any) => (_ctx.faturar(record))
                                        }, [
                                          _createVNode(_component_icone, {
                                            style: {"font-size":"18px"},
                                            nome: "dinheiro"
                                          })
                                        ], 8, _hoisted_39))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("a", {
                                      class: "visualizar",
                                      title: "Emitir documento fiscal",
                                      onClick: ($event: any) => (_ctx.emitirNotaFiscal(record))
                                    }, [
                                      _createVNode(_component_icone, {
                                        style: {"font-size":"18px"},
                                        nome: "documento-aprovado"
                                      })
                                    ], 8, _hoisted_40)
                                  ]))
                                : _createCommentVNode("", true)
                  ]),
                  emptyText: _withCtx(() => [
                    (_ctx.state.faturamentos.length <= 0)
                      ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                          key: 0,
                          mensagem: "Nenhuma movimentação encontrado"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "data-source", "scroll", "loading"]))
              ]),
              _createVNode(_component_faturamento_vendas_modal, {
                visivel: _ctx.state.apresentarModal,
                "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.apresentarModal) = $event)),
                faturamento: _ctx.state.faturamentoSelecionado,
                empresa: _ctx.state.filtros.empresas[0],
                onConfirmacao: _cache[19] || (_cache[19] = ($event: any) => (_ctx.atualizarInformacoesTela()))
              }, null, 8, ["visivel", "faturamento", "empresa"]),
              _createVNode(_component_requisicao_modal, {
                visivel: _ctx.modalBase.exibirRequisicaoModal,
                "onUpdate:visivel": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
                retornoRequisicao: _ctx.modalBase.retornoRequisicao,
                apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
                fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
              }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}